import script from "./MigrateItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrateItemModal.vue?vue&type=script&setup=true&lang=js"

import "./MigrateItemModal.vue?vue&type=style&index=0&id=0e4d7907&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e4d7907"]])

export default __exports__